import { render } from "./agent.documents.vue?vue&type=template&id=0364cdfc"
import script from "./agent.documents.vue?vue&type=script&lang=js"
export * from "./agent.documents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__